<template>
  <div class="l-m-background">
    <div class="header">背景管理</div>
    <div class="body"
         :style="getHeightStyle()">
      <div class="item"
           v-for="(item, index) in BackgroundsList"
           :key="index">
        <div class="item-img"
             @click="setProjectBackground(item)"
             :class="{ active: item.componentName === $store.state.ProjectInfo.Background.componentName }"
             draggable="false">
          <img class="img"
               :src="item.componentOverViewImg"
               alt="" />
        </div>
        <div class="item-name">{{ item.componentTitle }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapMutations } from 'vuex';
export default {
  name: 'LMBackground',
  components: {},
  data () {
    return {};
  },
  created () {
    // console.log(this.BackgroundsList, 'this.BackgroundsList');
  },
  mounted () {
    [this.BackgroundsList[1], this.BackgroundsList[2]] = [this.BackgroundsList[2], this.BackgroundsList[1]];
  },
  computed: {
    ...mapState({
      // 背景管理 数据
      BackgroundsList: state => state.BackgroundsList,
      isChangeBk: state => state.ProjectInfo.CurrentScene?.isChangeBk,
    }),
  },
  methods: {
    ...mapMutations(['set_ProjectBackground', 'set_CurrentConfigration']),
    getHeightStyle () {
      return {
        height: this.$store.state.ClientViewSize.height - 80 + 'px',
      };
    },
    setProjectBackground (config) {
      if (!this.isChangeBk) {
        this.set_ProjectBackground(config);
        this.set_CurrentConfigration(config);
      } else {
        this.$ElMessage({
          type: 'warning',
          message: "该场景指定了背景，此处不能切换！"
        })
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.l-m-background {
  width: 240px;
  height: 100%;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .header {
    width: 100%;
    height: 40px;
    line-height: 40px;
    white-space: nowrap;
    text-align: center;
    font-size: 14px;
    color: $font-color-base;
    user-select: none;
    background-color: #2c2e3f;
  }

  .body {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: scroll;

    padding: 20px 0px 50px 0px;
    &::-webkit-scrollbar-thumb {
      background: #191e29 !important;
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar {
      width: 4px !important;
      height: 3px !important;
    }
    &::-webkit-scrollbar-track {
      background: #43455800;
    }

    .item-list {
      margin-bottom: 100px;
    }

    .item {
      margin: 0 auto;
      // background-color: rosybrown;
      width: 100%;
      height: 160px;
      // margin-bottom: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .item-img {
        overflow: hidden;
        cursor: pointer;
        width: 202px;
        height: 128px;
        box-sizing: border-box;
        background-color: rgba(20, 20, 27, 0.733);
        border: 1px solid rgba(0, 0, 0, 0);
        transition: border 0.2s;
        border-radius: 5px;
        &:hover {
          border: 1px solid rgb(70, 59, 226);
        }
        .img {
          width: 202px;
          height: 128px;
        }
      }
      .active {
        border: 1px solid rgb(74, 62, 247);
        pointer-events: none;
      }
      .item-name {
        user-select: none;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        color: $font-color-base;
      }
    }
  }
}
</style>